"use client";

import { Card, CardContent } from "@workspace/ui/components/card";
import { Skeleton } from "@workspace/ui/components/skeleton";

interface ArtistContentSkeletonProps {
	type?: "festivals" | "sets" | "shows";
}

export function ArtistContentSkeleton({ type = "festivals" }: ArtistContentSkeletonProps) {
	// Different poster sizes based on content type
	// Shows: 1:1 aspect ratio (h-16 w-16)
	// Festivals/Sets: 3:4 aspect ratio (w-16 h-[5.33rem])
	const posterClassName = type === "shows"
		? "h-16 w-16 flex-shrink-0 rounded-md"
		: "h-[5.33rem] w-16 flex-shrink-0 rounded-md";

	return (
		<div className="flex flex-1 flex-col">
			{/* Content skeleton - festival/set/show cards */}
			<div className="space-y-3">
				{[1, 2, 3, 4, 5, 6].map((id) => (
					<Card key={`content-skeleton-${id}`}>
						<CardContent className="p-3">
							<div className="flex gap-3">
								{/* Poster image skeleton - size varies by type */}
								<Skeleton className={posterClassName} />
								<div className="min-w-0 flex-1">
									{/* Primary text */}
									<Skeleton className="mb-2 h-5 w-3/4" />
									{/* Secondary text */}
									<Skeleton className="mb-1 h-4 w-1/2" />
									{/* Tertiary text */}
									<Skeleton className="mb-1 h-4 w-2/3" />
									{/* Additional info */}
									<Skeleton className="h-4 w-1/3" />
								</div>
							</div>
						</CardContent>
					</Card>
				))}
			</div>
		</div>
	);
}
